import { NgModule } from '@angular/core';

import { PatternBlockModule } from '../../../shared/pattern-block/pattern-block.module';
import { UIModule } from '../../../shared/ui';
import {
  BookRecallComponent,
  bookRecallResolver,
} from './book-recall.component';

const MODULES = [PatternBlockModule, UIModule];

const DECLARATIONS = [BookRecallComponent];

@NgModule({
  imports: [...MODULES],
  declarations: [...DECLARATIONS],
  exports: [...MODULES, ...DECLARATIONS],
})
export class BookRecallModule {
  static entry = BookRecallComponent;
  static componentDataResolver = bookRecallResolver;
}
